"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Crown;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Crown(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "crown"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "outline-4",
    "data-name": "outline",
    d: "M92.245,35.385a2.5,2.5,0,0,0-2.176-1.4A38.714,38.714,0,0,0,64.231,44.461c-1.772-5.194-5.555-13.937-12.465-20.376a2.5,2.5,0,0,0-1.7-.671h-.124a2.5,2.5,0,0,0-1.7.671c-6.91,6.439-10.693,15.182-12.465,20.376A38.721,38.721,0,0,0,9.931,33.984a2.5,2.5,0,0,0-1.947,3.978c9.317,12.7,13.305,36.3,13.344,36.532a2.5,2.5,0,0,0,4.934-.815c-.151-.911-3.437-20.368-11.375-34.228a33.2,33.2,0,0,1,20.1,11.519,2.5,2.5,0,0,0,4.375-1.031C39.39,49.812,42.172,37.864,50,29.4c7.828,8.469,10.61,20.417,10.639,20.542a2.5,2.5,0,0,0,4.376,1.033A33.314,33.314,0,0,1,85.1,39.469c-7.932,13.857-11.215,33.3-11.366,34.21a2.5,2.5,0,0,0,4.934.815c.039-.237,4.027-23.828,13.344-36.532A2.5,2.5,0,0,0,92.245,35.385Z"
  }))));
}